import { GscService } from "..";
import { GscResponseCode } from "../types";
import { GscBasket } from "./types";

class GscBasketService extends GscService {
  private BASKET_ENDPOINT = "/basket/indexAjax";

  async add(
    productId: number,
    quantity: number,
    type?: string // TODO: should be enumed
  ): Promise<GscBasket> {
    try {
      const res = await this.postForm(this.BASKET_ENDPOINT, {
        action: "add",
        work_id: productId,
        quantity,
        type: type ?? "",
      });

      if (res.status === GscResponseCode.NotFound) {
        throw new Error("Product not found");
      }

      if (res.status !== GscResponseCode.Ok) {
        throw new Error("Unknown error has occured");
      }

      return (await res.json()) as GscBasket;
    } catch (e) {
      console.error(e);
      throw "Unknown error has occured";
    }
  }
}

export const basketService = new GscBasketService();
